export const FETCH_EXPENSES_SUCCESS = 'fetch_expenses_success'
export const FETCH_EXPENSE_DETAILS_SUCCESS = 'fetch_expense_details_success'
export const SWAP_EXPENSE = 'swap_expense'
export const FETCH_EXPENSE_COUNTS_SUCCESS = 'fetch_expense_counts_success'
